export * from './lib/pipes/locale-date.pipe';
export * from './lib/providers/locale/locale.provider';
export * from './lib/services/custom-lang-loader';
export * from './lib/services/custom-paginator';
export * from './lib/services/tab-title-strategy';
export * from './lib/services/translator';
export * from './lib/utils';
